import { Form, FormInstance, Select, Typography } from "antd";
import Arrowdown from "../../../common/images/png/ArrowDown.png";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as PlusDisabledIcon } from "../../../common/images/svg/PlusDisabled.svg";
import { ReactComponent as PlusGradientIcon } from "../../../common/images/svg/PlusGradient.svg";
import { ReactComponent as ArrowIcon } from "../../../common/images/svg/SuffixSelectIcon.svg";

const { Option } = Select;

interface ISelectBankAccountProps {
  isTablet: boolean;
  form: FormInstance<any>;
  listBankAccount: any[];
  bankAccountSelected: any;
  setBankAccountSelected: React.Dispatch<any>;
  paramsBankAccount: {
    start: number;
    end: number;
  };
  setParamsBankAccount: React.Dispatch<
    React.SetStateAction<{
      start: number;
      end: number;
    }>
  >;
  setOpenAddBankAccount: React.Dispatch<React.SetStateAction<boolean>>;
  loading?: boolean;
}

const SelectBankAccount = (props: ISelectBankAccountProps) => {
  const {
    isTablet,
    form,
    listBankAccount,
    setBankAccountSelected,
    bankAccountSelected,
    paramsBankAccount,
    setParamsBankAccount,
    setOpenAddBankAccount,
    loading = true,
  } = props;

  return (
    <div>
      <div className="input-recipient-wallet">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            width: "100%",
          }}
        >
          <Form.Item
            style={{ width: "100%" }}
            label="Beneficiary Bank Account"
            name="beneficiary_bank_account"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Select
              showSearch
              disabled={
                !form.getFieldValue("beneficiary") || !listBankAccount.length
              }
              className="select-recipient"
              popupClassName="select-beneficiary"
              placeholder="Choose a bank account"
              suffixIcon={<ArrowIcon />}
              optionLabelProp="label"
              onChange={(id) => {
                const selected = listBankAccount?.find(
                  (item: any) => item.id === id
                );
                setBankAccountSelected(selected);
              }}
              filterOption={(input, option: any) => {
                const bankAccount = listBankAccount.find(
                  (w) => w.id === option.value
                );
                return (
                  bankAccount?.accountNumber
                    ?.toLowerCase()
                    .includes(input.toLowerCase()) ||
                  bankAccount?.bank?.name
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
                );
              }}
            >
              {Array.isArray(listBankAccount) &&
                listBankAccount.map((item: any) => (
                  <Option
                    key={item.id}
                    value={item.id}
                    label={
                      <span className="ant-select-custom-value-sendmoney">
                        {item.accountNumber}
                      </span>
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span className="ant-select-custom-value-sendmoney">
                        {item?.accountNumber}
                      </span>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          {item?.bank?.name}
                        </span>
                        <div className="dot-transaction"></div>
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          {item?.bank?.country}
                        </span>
                      </div>
                    </div>
                    {bankAccountSelected?.id === item?.id && (
                      <CheckSelectIcon />
                    )}
                  </Option>
                ))}
              {listBankAccount.length === paramsBankAccount.end && (
                <Option key="load-more" disabled>
                  <span
                    style={{
                      fontSize: isTablet ? 12 : 14,
                      color: "rgba(29, 171, 241, 1)",
                      fontWeight: 500,
                      cursor: "pointer",
                      height: "66px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setParamsBankAccount((prev) => ({
                        ...prev,
                        end: prev.end + 10,
                      }));
                    }}
                  >
                    Load more <img src={Arrowdown} />
                  </span>
                </Option>
              )}
            </Select>
          </Form.Item>
          {loading || form.getFieldValue("beneficiary") ? null : (
            <>
              <Typography
                style={{
                  fontSize: isTablet ? 10 : 12,
                  fontWeight: 400,
                  color: "#EC3333",
                }}
              >
                {
                  "Please select a beneficiary before choosing a bank account."
                }
              </Typography>
            </>
          )}
          {!loading &&
            form.getFieldValue("beneficiary") &&
            listBankAccount.length === 0 ? (
            <>
              <Typography
                style={{
                  fontSize: isTablet ? 10 : 12,
                  fontWeight: 400,
                  color: "#EC3333",
                }}
              >
                {
                  "No bank account found for the selected currency. Click 'Add' to set one up"
                }
              </Typography>
            </>
          ) : null}
        </div>
        <div
          className={`button-add-new-recipient ${form.getFieldValue("beneficiary")
            ? ""
            : "button-add-new-recipient-disabled"
            }`}
          onClick={() => {
            if (form.getFieldValue("beneficiary")) setOpenAddBankAccount(true);
          }}
        >
          {form.getFieldValue("beneficiary") ? (
            <PlusGradientIcon />
          ) : (
            <PlusDisabledIcon />
          )}
        </div>
      </div>
      {bankAccountSelected ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            marginTop: 8,
          }}
        >
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Name: {bankAccountSelected?.bank?.name}
          </Typography>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Swift: {bankAccountSelected?.bank?.swift}
          </Typography>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Address: {bankAccountSelected?.bank?.legalAddress}
          </Typography>
        </div>
      ) : null}
    </div>
  );
};

export default SelectBankAccount;
